import { Grid2, Typography } from '@mui/material';

interface Props {
  label: string;
  value?: string | number | null;
  formatter?: (value?: string | number | null) => string;
}

export const InsuranceBrokerDetailsRow = ({ label, value, formatter }: Props) => {
  return (
    <Grid2 container size={12} borderBottom="1px solid #0000001f">
      <Grid2 size={6}>
        <Typography variant="body1" sx={{ color: '#00000099' }}>
          {label}
        </Typography>
      </Grid2>
      <Grid2 size={6}>
        <Typography variant="body1"> {value ? (formatter ? formatter(value) : value) : '-'}</Typography>
      </Grid2>
    </Grid2>
  );
};
